<template>
    <div>
        <div style="display: flex; align-items: center; justify-content: space-between">
            <a-breadcrumb style="margin: 16px 0">
                <a-breadcrumb-item>主页</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
            </a-breadcrumb>
            <div>
                <a-button icon="sync" @click="apiDistributorChargesList">刷新</a-button>
            </div>
        </div>

        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="分销流水查询">
                <div class="qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">费用类型：</div>
                        <a-select v-model="query.chargesType" @change="resetChargesState()">
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option :value="1">分销所得</a-select-option>
                            <a-select-option :value="2">授信余额操作(加)</a-select-option>
                            <a-select-option :value="-2">授信余额操作(减)</a-select-option>
                            <a-select-option :value="3">提现失败退回</a-select-option>
                            <a-select-option :value="4">退款增加</a-select-option>
                            <a-select-option :value="5">授信转账户余额</a-select-option>
                            <a-select-option :value="6">账户余额转授信余额</a-select-option>
                            <a-select-option :value="7">账户余额操作(加)</a-select-option>
                            <a-select-option :value="-7">账户余额操作(减)</a-select-option>
                            <a-select-option :value="-1">出票扣款</a-select-option>
                            <a-select-option :value="-3">提现</a-select-option>
                            <a-select-option :value="8">余额转换增加</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">费用状态：</div>
                        <a-select v-model="query.chargesState">
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option :value="3">正常</a-select-option>
                            <a-select-option :value="4">冻结</a-select-option>
                            <a-select-option :value="5">审核中</a-select-option>
                            <a-select-option :value="6">已拒绝</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">服务商：</div>
                        <a-select v-model="query.facilitatorId" @change="apiDistributorChargesList">
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option v-for="(item, index) in facilitatorList" :key="index" :value="item.facilitatorId">{{ item.facilitatorName }}</a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="qinang-margin-top-12 qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">查询日期：</div>
                        <a-date-picker v-model="query.startTime" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
                        <span style="width: 20px; text-align: center">-</span>
                        <a-date-picker class="qinang-search-time-picker-2" v-model="query.endTime" format="YYYY-MM-DD" />
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">分销商：</div>
                        <a-input v-model="query.distributorName" placeholder="请输入分销商名称" />
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">订单编号：</div>
                        <a-input placeholder="请输入订单编号" v-model="query.orderId" />
                    </div>
                </div>

                <div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center">
                    <a-button type="primary" icon="search" @click="apiDistributorChargesList">查询</a-button>
                    <a-button icon="redo" @click="resetQuery" style="margin-left: 14px">重置</a-button>
                </div>
            </a-collapse-panel>
        </a-collapse>

        <div class="qinang-card">
            <a-table :columns="tableColumns" :data-source="tableData" row-key="distributorChargesId" :loading="tableLoading" :pagination="false">
                <span slot="chargesType" slot-scope="text, record">
                    {{ chargesTypeMap.find(item => item.value === record.chargesType)?.label || record.chargesType }}
                </span>
                <span slot="sourceType" slot-scope="text, record">
                    {{ sourceTypeMap.find(item => item.value === record.sourceType)?.label || record.sourceType }}
                </span>
                <span slot="distributor" slot-scope="text, record">
                    {{ distributorName(record.distributorId) }}
                </span>
                <span slot="ordersTotal" slot-scope="text, record">
                    {{ (record.ordersTotal / 100).toFixed(2) }}
                </span>
                <span slot="beforeSurplusPrice" slot-scope="text, record">
                    {{ (record.beforeSurplusPrice / 100).toFixed(2) }}
                </span>
                <span slot="money" slot-scope="text, record">
                    {{ (record.money / 100).toFixed(2) }}
                </span>
                <span slot="chargesState" slot-scope="text, record">
                    {{ chargesStateMap.find(item => item.value === record.chargesState)?.label || record.chargesState }}
                </span>
                <span slot="createTime" slot-scope="text, record">
                    {{ qaUtil.timeFormat(record.createTime) }}
                </span>
                <span slot="orderId" slot-scope="text, record">
                    <a-button v-if="record.orderId" type="link" @click="showOrderDetail(record)">{{ record.orderId }}</a-button>
                    <span v-else>-</span>
                </span>
                <span slot="tableAction" slot-scope="text, record">
                    <a-button type="link" @click="showDetail(record)">详情</a-button>
                </span>
            </a-table>
            <a-pagination style="text-align: right; margin: 10px" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']" :show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange" />
        </div>

        <a-modal class="qa-modal-half" width="600px" title="分销流水详情" :visible="detailVisible" @ok="detailVisible = false" @cancel="detailVisible = false" :maskClosable="false" :keyboard="false">
            <a-descriptions bordered :column="1" size="small" v-if="detailData">
                <a-descriptions-item label="流水ID">{{ detailData.distributorChargesId }}</a-descriptions-item>
                <a-descriptions-item label="交易流水号">{{ detailData.serialNo }}</a-descriptions-item>
                <a-descriptions-item label="真实姓名">{{ detailData.realName }}</a-descriptions-item>
                <a-descriptions-item label="受分销人">{{ detailData.touristName }}</a-descriptions-item>
                <a-descriptions-item label="订单编号">{{ detailData.orderId }}</a-descriptions-item>
                <a-descriptions-item label="费用类型">
                    {{ chargesTypeMap.find(item => item.value === detailData.chargesType)?.label || detailData.chargesType }}
                </a-descriptions-item>
                <a-descriptions-item label="操作账户">
                    {{ sourceTypeMap.find(item => item.value === detailData.sourceType)?.label || detailData.sourceType }}
                </a-descriptions-item>
                <a-descriptions-item label="订单总额(元)">{{ (detailData.ordersTotal / 100).toFixed(2) }}</a-descriptions-item>
                <a-descriptions-item label="变动前余额(元)">{{ (detailData.beforeSurplusPrice / 100).toFixed(2) }}</a-descriptions-item>
                <a-descriptions-item label="变化金额(元)">{{ (detailData.money / 100).toFixed(2) }}</a-descriptions-item>
                <a-descriptions-item label="费用状态">
                    {{ chargesStateMap.find(item => item.value === detailData.chargesState)?.label || detailData.chargesState }}
                </a-descriptions-item>
                <a-descriptions-item label="银行卡号">{{ detailData.bankCard }}</a-descriptions-item>
                <a-descriptions-item label="银行名">{{ detailData.bankName }}</a-descriptions-item>
                <a-descriptions-item label="创建时间">{{ qaUtil.timeFormat(detailData.createTime) }}</a-descriptions-item>
            </a-descriptions>
        </a-modal>

        <a-modal class="qa-modal" width="100%" title="订单详情" :visible="orderDetailVisible" @ok="orderDetailVisible = false" @cancel="orderDetailVisible = false" :maskClosable="false" :keyboard="false">
            <OrderInfo v-if="orderDetailVisible" :ordersNumber="orderNumber"></OrderInfo>
        </a-modal>
    </div>
</template>

<script>
import moment from "moment"
import OrderInfo from "../offlineReport/OrderInfo.vue"
export default {
    components: { OrderInfo },
    data() {
        return {
            moment,
            selectFirstMenu: window.sessionStorage.getItem("selectFirstMenu"),
            selectSecondMenu: window.sessionStorage.getItem("selectSecondMenu"),
            detailVisible: false,
            detailData: null,
            orderDetailVisible: false,
            orderNumber: undefined,
            query: {
                page: 1,
                size: 10,
                total: 0,
                facilitatorId: 0,
                chargesType: 0,
                chargesState: 0,
                distributorName: undefined,
                orderId: undefined,
                startTime: moment().format("YYYY-MM-DD"),
                endTime: moment().format("YYYY-MM-DD")
            },
            tableData: [],
            facilitatorList: [],
            tableColumns: [
                { title: "流水ID", dataIndex: "distributorChargesId", key: "distributorChargesId", align: "center" },
                { title: "订单编号", key: "orderId", align: "center", scopedSlots: { customRender: "orderId" } },

                { title: "分销商", key: "distributor", align: "center", scopedSlots: { customRender: "distributor" } },
                { title: "费用类型", key: "chargesType", align: "center", scopedSlots: { customRender: "chargesType" } },
                { title: "操作账户", key: "sourceType", align: "center", scopedSlots: { customRender: "sourceType" } },
                { title: "订单总额(元)", key: "ordersTotal", align: "center", scopedSlots: { customRender: "ordersTotal" } },
                { title: "变动前余额(元)", key: "beforeSurplusPrice", align: "center", scopedSlots: { customRender: "beforeSurplusPrice" } },
                { title: "变化金额(元)", key: "money", align: "center", scopedSlots: { customRender: "money" } },
                { title: "余额状态", key: "chargesState", align: "center", scopedSlots: { customRender: "chargesState" } },
                { title: "创建时间", key: "createTime", align: "center", scopedSlots: { customRender: "createTime" } },
                { title: "操作", key: "tableAction", align: "center", scopedSlots: { customRender: "tableAction" } }
            ],
            tableLoading: false,
            chargesTypeMap: [
                { label: "分销所得", value: 1 },
                { label: "授信余额操作(加)", value: 2 },
                { label: "授信余额操作(减)", value: -2 },
                { label: "提现失败退回", value: 3 },
                { label: "退款增加", value: 4 },
                { label: "授信转账户余额", value: 5 },
                { label: "账户余额转授信余额", value: 6 },
                { label: "账户余额操作(加)", value: 7 },
                { label: "账户余额操作(减)", value: -7 },
                { label: "出票扣款", value: -1 },
                { label: "提现", value: -3 },
                { label: "余额转换增加", value: 8 }
            ],
            chargesStateMap: [
                { label: "正常", value: 3 },
                { label: "冻结", value: 4 },
                { label: "审核中", value: 5 },
                { label: "已拒绝", value: 6 }
            ],
            sourceTypeMap: [
                { label: "账户余额", value: 1 },
                { label: "授信余额", value: 2 }
            ]
        }
    },
    methods: {
        async apiFacilitatorListForStaff() {
            const { data: res } = await this.$http.post(this.navigation.apiFacilitatorListForStaff, { staffId: window.sessionStorage.getItem("staffId") })
            if (res.code == 200) {
                this.facilitatorList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        async apiDistributorChargesList() {
            let queryData = JSON.parse(JSON.stringify(this.query))
            if (queryData.chargesType === 0) queryData.chargesType = null
            if (queryData.chargesState === 0) queryData.chargesState = null
            if (queryData.facilitatorId === 0) queryData.facilitatorId = null
            if (queryData.distributorName === "" || queryData.distributorName === undefined) queryData.distributorName = null
            if (queryData.orderId === "" || queryData.orderId === undefined) queryData.orderId = null
            queryData.startTime = this.moment(queryData.startTime).format("YYYY-MM-DD")
            queryData.endTime = this.moment(queryData.endTime).format("YYYY-MM-DD")
            this.tableLoading = true
            const { data: res } = await this.$http.post(this.navigation.apiDistributorChargesQueryList, queryData)
            if (res.code == 200) {
                this.tableData = res.data.list
                this.query.page = res.data.pages.page
                this.query.size = res.data.pages.size
                this.query.total = res.data.pages.total
                this.tableLoading = false
            } else {
                this.$message.error(res.msg)
                this.tableLoading = false
            }
        },
        async showDetail(record) {
            const { data: res } = await this.$http.post(this.navigation.apiDistributorChargesDetail, { distributorChargesId: record.distributorChargesId })
            if (res.code == 200) {
                this.detailData = res.data
                this.detailVisible = true
            } else {
                this.$message.error(res.msg)
            }
        },
        pageChange(page, pageSize) {
            this.query.page = page
            this.query.size = pageSize
            this.apiDistributorChargesList()
        },
        showSizeChange(current, size) {
            this.query.page = current
            this.query.size = size
            this.apiDistributorChargesList()
        },
        resetQuery() {
            this.query = {
                page: 1,
                size: 10,
                total: 0,
                facilitatorId: 0,
                chargesType: 0,
                chargesState: 0,
                distributorName: undefined,
                orderId: undefined,
                startTime: moment().format("YYYY-MM-DD"),
                endTime: moment().format("YYYY-MM-DD")
            }
            this.apiDistributorChargesList()
        },

        resetChargesState() {
            this.query.chargesState = 0
        },
        distributorName(distributorId) {
            if (!distributorId) return ""
            const d = this.distributorList.find(item => item.distributorId == distributorId)
            return d ? d.distributorName : distributorId
        },
        async apiDistributorList() {
            const { data: res } = await this.$http.post(this.navigation.apiDistributorList, {})
            if (res.code == 200) {
                this.distributorList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        showOrderDetail(record) {
            this.orderNumber = record.orderId
            this.orderDetailVisible = true
        }
    },
    created() {
        this.apiFacilitatorListForStaff()
        this.apiDistributorChargesList()
        this.apiDistributorList()
    }
}
</script>

<style scoped></style>
